import React from 'react'
import { PlayerContext, PlayerContextProps } from './PlayerContext'

export function usePlayer(): PlayerContextProps {
    return React.useContext(PlayerContext)
}